import React from 'react';

import { SplashScreen } from '@/components/SplashScreen';
import { useFacilitySettingsQueries } from '@/pages/CRM/Screener/hooks/useFacilitySettingsQuery';

interface ScreenerSettingsGuardProps {
  facilityIds: string[];
}

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const ScreenerSettingsGuard: React.FC<
  React.PropsWithChildren<ScreenerSettingsGuardProps>
> = ({ facilityIds, children }) => {
  const queries = useFacilitySettingsQueries(facilityIds, {
    staleTime: FIVE_MINUTES_MS
  });

  const initialLoadDone =
    facilityIds.length === 0 || queries.every((q) => q.isSuccess || q.isError);

  if (!initialLoadDone) {
    return <SplashScreen />;
  }

  return <>{children}</>;
};
